module.exports = __webpack_public_path__ + "88f0e9b82d76cfbf6f2cd294657479dd.pdf";